import { UpdateConsentOptions, CookieChangeEvent } from '../shared/interfaces';
import { setCookie, getCookie, isSupportCookieStore } from '../shared/functions';
import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', async (): Promise<void> => {
    const cookieNotification = document.getElementById(constants.targets.cookie.notification);
    if (!cookieNotification) return;

    const cookieToggle = document.getElementById(constants.targets.cookie.toggle);
    const cookieToggleFooter = document.getElementById(constants.targets.cookie.toggleFooter);
    const accept = cookieNotification.querySelector<HTMLElement>(constants.targets.cookie.accept);
    const refuse = cookieNotification.querySelector<HTMLElement>(constants.targets.cookie.refuse);
    const close = cookieNotification.querySelector<HTMLElement>(constants.targets.cookie.close);

    if (!cookieToggle || !accept || !refuse) return;

    const acceptIconEl = accept.querySelector<HTMLElement>(constants.targets.cookie.icon);
    const acceptTextEl = accept.querySelector<HTMLElement>(constants.targets.cookie.text);
    const acceptText = accept.dataset.acceptText;
    const acceptedText = accept.dataset.acceptedText;

    if (!window.dataLayer) window.dataLayer = [];

    const updateConsent = ({ hasConsent, cookieConsent = null }: UpdateConsentOptions): void => {
        if (hasConsent) {
            cookieNotification.classList.add(constants.classes.softHidden);
            cookieToggle.classList.remove(constants.classes.softHidden);
        } else {
            cookieNotification.classList.remove(constants.classes.softHidden);
            cookieToggle.classList.add(constants.classes.softHidden);
        }

        if (acceptIconEl && acceptTextEl && acceptText && acceptedText) {
            if (cookieConsent === true) {
                acceptIconEl.classList.remove(constants.classes.hidden);
                acceptTextEl.textContent = acceptedText;
            } else if (cookieConsent === false) {
                acceptIconEl.classList.add(constants.classes.hidden);
                acceptTextEl.textContent = acceptText;
            }
        }
    };

    const cookieConsentRaw = await getCookie(constants.cookies.consent);
    const cookieConsent: boolean | null =
        cookieConsentRaw === 'true' ? true :
            cookieConsentRaw === 'false' ? false :
                null;

    updateConsent({ hasConsent: cookieConsent !== null, cookieConsent });

    accept.addEventListener('click', async () => {
        await setCookie(constants.cookies.consent, 'true', 365);
        updateConsent({ hasConsent: true, cookieConsent: true });
    });

    refuse.addEventListener('click', async () => {
        await setCookie(constants.cookies.consent, 'false', 365);
        updateConsent({ hasConsent: true, cookieConsent: false });
    });

    if (close) {
        close.addEventListener('click', () => updateConsent({ hasConsent: true }));
    }

    cookieToggle.addEventListener('click', () => updateConsent({ hasConsent: false }));

    if (cookieToggleFooter) {
        cookieToggleFooter.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            updateConsent({ hasConsent: false });
        });
    }

    if (isSupportCookieStore) {
        (window as any).cookieStore.addEventListener('change', async ({ changed, deleted }: CookieChangeEvent) => {
            const occChanged = changed.find(c => c.name === constants.cookies.consent);
            const occDeleted = deleted.find(c => c.name === constants.cookies.consent);

            if (!occChanged && !occDeleted) return;

            let newConsent: boolean | null = null;
            if (occChanged) {
                newConsent =
                    occChanged.value === 'true' ? true :
                        occChanged.value === 'false' ? false :
                            null;
            }

            updateConsent({ hasConsent: !!(occChanged || occDeleted), cookieConsent: newConsent });
        });
    }
});
